/* eslint-disable unused-imports/no-unused-vars */
/**
 * Store para cuentas x pagar para la revision 2
 * SOLO deben declarase aquí lo relacionado con las CUENTAS X PAGAR
 *
 * para acceder a las actions de este store hay que usar el siguiente formato:
 * ...mapActions({
 *  ...
 *  action: 'cuentasxpagar/v2/<action_name>',
 *  ...
 * })
 */
import axios from '@axios'
import { defineStore } from '@core/utils/vuex'
import reembolso from '../reembolso-interno'

export default defineStore({
    namespaced: true,
    state: {
        ordenPago: [],
        tiposDocumentosE: [],
        Anticipos: [],
        PendientesAprobacion: [],
        NivelAprobacionAnticipos: [],
        SaldoPendienteOrdenPago: [],
        Abonos: [],
        RegistroDocumento: [],
        infoTributariaDefault: [],
        saldosAnticipo: [],
        reembolsoInterno: [],
        obligacionesXsemana: null,
        jefeAsignacion: [],
        personalAsignado: [],
        documentosElectronicos: [],
    },
    getters: {
        getOrdenPago(state) {
            return state.ordenPago
        },
        getTipoDocumentoE(state) {
            return state.tiposDocumentosE
        },
        getAnticipos(state) {
            return state.Anticipos
        },
        getPendientesAprobacion(state) {
            return state.PendientesAprobacion
        },
        getNivelAprobacionAnticipos(state) {
            return state.NivelAprobacionAnticipos
        },
        getSaldoPendienteOrdenPago(state) {
            return state.SaldoPendienteOrdenPago
        },
        getAbonos(state) {
            return state.Abonos
        },
        getRegistroDocumento(state) {
            return state.RegistroDocumento
        },
        getInfoTributariaDefault(state) {
            return state.infoTributariaDefault
        },
        getSaldosAnticipo(state) {
            return state.saldosAnticipo
        },
        getObligacionesXsemana(state) {
            return state.obligacionesXsemana
        },
        getJefeAsignacion(state) {
            return state.jefeAsignacion
        },
        getPersonalAsignado(state) {
            return state.personalAsignado
        },
        getDocumentosElectronicos(state) {
            return state.documentosElectronicos
        },
    },
    mutations: {
        setOrdenPago(state, ordenPago) {
            state.ordenPago = ordenPago
        },
        setReembolsoInterno(state, reembolsoInterno) {
            state.reembolsoInterno = reembolsoInterno
        },
        setTipoDocumentoE(state, tiposDocumentosE) {
            state.tiposDocumentosE = tiposDocumentosE
        },
        setAnticipos(state, Anticipos) {
            state.Anticipos = Anticipos
        },
        setPendientesAprobacion(state, PendientesAprobacion) {
            state.PendientesAprobacion = PendientesAprobacion
        },
        setNivelAprobacionAnticipos(state, NivelAprobacionAnticipos) {
            state.NivelAprobacionAnticipos = NivelAprobacionAnticipos
        },
        setSaldoPendienteOrdenPago(state, SaldoPendienteOrdenPago) {
            state.SaldoPendienteOrdenPago = SaldoPendienteOrdenPago
        },
        setAbonos(state, Abonos) {
            state.Abonos = Abonos
        },
        setRegistroDocumento(state, RegistroDocumento) {
            state.RegistroDocumento = RegistroDocumento
        },
        setInfoTributariaDefault(state, infoTributariaDefault) {
            state.infoTributariaDefault = infoTributariaDefault
        },
        setSaldosAnticipo(state, saldosAnticipo) {
            state.saldosAnticipo = saldosAnticipo
        },
        setObligacionesXsemana(state, obligacionesXsemana) {
            state.obligacionesXsemana = obligacionesXsemana
        },
        setJefeAsignacion(state, jefeAsignacion) {
            state.jefeAsignacion = jefeAsignacion
        },
        setPersonalAsignado(state, personalAsignado) {
            state.personalAsignado = personalAsignado
        },
        setDocumentosElectronicos(state, documentosElectronicos) {
            state.documentosElectronicos = documentosElectronicos
        },
    },
    actions: {
        async descargarProveedorInterno({ commit }) {
            return (
                await axios.get('/api/auth/cxp/reembolsos-internos/plantilla', {
                    responseType: 'arraybuffer',
                })
            ).data
        },

        fetchOrdenPago({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/ordenes-pago', { params: data })
                    .then(response => {
                        commit('setOrdenPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoComprobantesE({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/cxp/reembolsos-internos/tipo-documento')
                    .then(response => {
                        commit('setTipoDocumentoE', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchOrdenesPagoByRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/ordenes-pago/by-registro-documento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /** REEMBOLSO INTERNO */
        fetchCreateReembolsoInterno({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/reembolsos-internos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReembolsoInterno({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/reembolsos-internos', { params: data })
                    .then(response => {
                        commit('setReembolsoInterno', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstadoCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/estado-cuenta', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        putReembolsoInterno({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`api/auth/cxp/reembolsos-internos/${data.id_solicitud_reembolso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /** FETCHS DE ANTICIPOS */
        fetchAnticipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/anticipo', { params: data })
                    .then(response => {
                        commit('setAnticipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/anticipo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`api/auth/cxp/anticipo/${data.id_anticipo}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnticiposPendientesAprobacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/anticipo/pendientes-aprobacion', { params: data })
                    .then(response => {
                        commit('setPendientesAprobacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAprobarAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/anticipo/aprobar-anticipo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchNivelAprobacionAnticipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/nivel-aprobacion-anticipo', { params: data })
                    .then(response => {
                        commit('setNivelAprobacionAnticipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateNivelAprobacionAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/nivel-aprobacion-anticipo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postStoreOrUpdateFechaLimiteRegDoc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/registro-documento/fecha-limite', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFechaLimiteRegDoc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/registro-documento/fecha-limite', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateNivelAprobacionAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`api/auth/cxp/nivel-aprobacion-anticipo/${data.id_nivel_aprobacion}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /** FETCHS DE ABONOS */
        fetchAbonos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/abonos', { params: data })
                    .then(response => {
                        commit('setAbonos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateAbono({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/abonos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateAbono({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`api/auth/cxp/abonos/${data.id_anticipo}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /** FETCHS DE REGISTRO DE DOCUMENTOS */
        fetchRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/registro-documento', { params: data })
                    .then(response => {
                        commit('setRegistroDocumento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/registro-documento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAnularRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/registro-documento/anular', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`api/auth/cxp/registro-documento/${data.registro.id_documento}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDescargarDocumentosRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/cxp/registro-documento/descargar-docs-retencion',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReportePdf({ commit }, id_documento) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/cxp/registro-documento/reporte-pdf',
                    responseType: 'blob',
                    params: { id_documento },
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSubirArchivoRD({ commit }, { id_documento, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/cxp/registro-documento/reporte/${id_documento}`, payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/cxp/registro-documento/enviar-correo-comprobante`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVisualizarTransaccion({ commit }, id_documento) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: `/api/auth/cxp/registro-documento/${id_documento}/reporte-transaccion-pdf`,
                    responseType: 'blob',
                    params: { id_documento },
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSaldosAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/cxp/saldos-anticipo/reporte-saldos-anticipo', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSaldosAnticipo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAprobarReembolsoInterno({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/reembolsos-internos/aprobacion-reembolso-interno', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRechazarReembolsoInterno({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/reembolsos-internos/rechazar-reembolso-interno', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteSaldoAnticipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/cxp/saldos-anticipo/reportes-saldos-anticipo', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteObligacionesXsemana({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/cxp/saldos-anticipo/reportes-obligaciones-x-semana', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObligacionesXsemana({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/cxp/saldos-anticipo/reporte-obligaciones-x-semana', {
                        params: data,
                    })
                    .then(response => {
                        commit('setObligacionesXsemana', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        /**
         * FETCHS DE ASIGNACION DE TAREAS
         */
        fetchJefeAsignacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/asignacion-tareas/index-jefe-asignacion', { params: data })
                    .then(response => {
                        commit('setJefeAsignacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateJefeAsignacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/asignacion-tareas/create-jefe-asignacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPersonalAsignado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/cxp/asignacion-tareas/index-personal-asignado', { params: data })
                    .then(response => {
                        commit('setPersonalAsignado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePersonalAsignado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/asignacion-tareas/create-personal-asignado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAsignarRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/asignacion-tareas/asignar-registro-documento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCruzarRegistroDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/registro-documento/cruzar-registro-documento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAnularDocumentoElectronico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/cxp/registro-documento/anular-documento-electronico', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
    modules: { reembolso },
})
